module.exports = __webpack_public_path__ + "static/media/artwork.4df0c68e.jpg";